import _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AlertService, Port, PortService } from 'app/services/index'
declare var $:any;
import { MapsAPILoader } from '@agm/core'; 
declare var google:any;
import { FormControl } from '@angular/forms';

@Component({
  selector: 'port-google-map',
  templateUrl: 'port-google-map.html',
  styles: [`
  agm-map {
    height: 800px;
    width: 100%;
  }`]
  
})
export class PortGoogleMapComponent {

    @Input() portList:Array<Port> = new Array();

    constructor(   
        private alertService:AlertService,
        private portService:PortService,
        private mapsAPILoader: MapsAPILoader,
    ) {
    }

    ngOnInit() {
        this.mapsAPILoader.load().then(() => {
            
        });
    }

    markerClick(event:any){
        console.log(event);
    }
}






// WEBPACK FOOTER //
// ./src/app/containers/port-map/port-google-map.ts